<template>
  <div>
    <template v-if="list">
      <el-image
        class="image-list"
        :style="'width:' + width + 'px;height:' + height + 'px'"
        :src="item"
        :preview-src-list="imagesArr"
        fit="contain"
        v-for="(item, index) in imagesArr"
        :key="index"
      >
        <div slot="error" class="image-slot"></div>
      </el-image>
    </template>
    <el-image
      :style="
        'text-align: center;width:' + width + 'px;height:' + height + 'px'
      "
      :src="firstImage"
      :preview-src-list="imagesArr"
      fit="contain"
      v-else
    >
      <div slot="error" class="image-slot">
        <img src="../../assets/noImage.png" style="width: 100%" />
      </div>
    </el-image>
  </div>
</template>
<script>
import AliossImg from "../../utils/aliossImg";

export default {
  props: {
    list: {
      type: Boolean,
      default: false,
    },
    images: String,

    width: {
      default: 70,
    },
    height: {
      default: 70,
    },
  },
  computed: {
    imagesArr() {
      if (this.images && this.images.trim()) {
        // let newImages = this.images.replace(
        //   /files.eshangying.com/g,
        //   "esyfiles.jianyingkeji.com"
        // );
        // let newImages2 = newImages
        //   .replace(
        //     /i.ebayimg.com/g,
        //     "images.weserv.nl/?url=https://i.ebayimg.com"
        //   )
        //   .split(";");
        // return newImages2.filter((s) => s.trim() !== "");
        return AliossImg.imgArr(
          this.images.split(";").filter((s) => s.trim() !== "")
        );
      } else {
        return [];
      }
    },
    firstImage() {
      if (this.images && this.images.trim()) {
        return AliossImg.firstImg(
          this.images.split(";").filter((s) => s.trim() !== "")
        );
      }
      return null;
    },
  },
};
</script>
<style>
.thumbnail {
  width: 70px;
  height: 80px;
}
.image-list {
  vertical-align: top;
  margin-right: 10px;
  margin-bottom: 10px;
}
.image-slot {
  text-align: center;
}
.el-image-viewer__mask {
  opacity: 0.9;
}
.el-image-viewer__wrapper {
  z-index: 3000 !important;
}
</style>